/**
 * File customer-quote-v2.js.
 *
 * Handles customer quote list blocks.
 */
(function ($) {
    'use strict';
    
    $(document).ready(function () {
        $('.customer-quote-v2').each(function (index) {
            $(`.customer-quote-v2 .customer-quote-v2__detail-row`).slick({
                autoplay: true,
                dots: true,
                infinite: true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
        });

        let slickSots  = $('.customer-quote-v2__detail-row ul.slick-dots li').length;
        let marginLeft = slickSots * 35;
        $('.customer-quote-v2__detail-row .slick-arrow.slick-next').css('left', marginLeft + 'px');

        if ( slickSots === 1 ) {
            $('.customer-quote-v2__detail-row ul.slick-dots li').hide();
        }
    });
})(jQuery);